<template>
  <div class="zoom">
    <router-link :to="{name:'tag'}" class="cross">
      <svg version="1.1" baseProfile="tiny" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
         x="0px" y="0px" width="20px" height="20px" viewBox="0 0 20 20" xml:space="preserve">
        <line fill="#FFFFFF" stroke="#FFFFFF" stroke-width="2" stroke-miterlimit="10" x1="0.5" y1="0.5" x2="19.4" y2="19.4"/>
        <line fill="#FFFFFF" stroke="#FFFFFF" stroke-width="2" stroke-miterlimit="10" x1="19.4" y1="0.5" x2="0.5" y2="19.4"/>
      </svg>
    </router-link>
    <div :class="{main:true, visible:hasVideo}">
      <div class="video">
        <video ref="video" loop  muted playsinline :src="project.video"></video>
      </div>
      <div class="right">
        <div class="about">
          <div class="title">
            <span v-html="project.title"></span><span v-if="project.year"></span>
            <div class="year">{{project.year}}</div>
          </div>
          <div class="text" v-html="project.text"></div>
          <div class="link">
            <span v-if="project.offline">{{project.link}}</span>
            <a v-if="!project.offline" :href="project.link" target="_blank">{{project.link}}</a>
            <div class="comment" v-if="project.comment">{{project.comment}}</div>
          </div>
        </div>
        <div class="tags">
          <div class="tag" v-for="tag in tags">
            <router-link :to="{name:'tag',params:{tag:tag.name}}">– {{tag.title}} </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default{
    data() {
      return {
        hasVideo: false
      }
    },
    props: {
      project: Object,
      tags: Array
    },
    mounted() {
      this.$refs.video.play();
      this.$refs.video.addEventListener('loadeddata', () => {
         this.hasVideo = true;
      }, false);
    }
  }
</script>
<style lang="scss">

.zoom {
  position: fixed;
  top:0;
  left:0;
  width: 100%;
  height: 100vh;
  // overflow-y:scroll;
  z-index: 30;
  background-color: black;
  padding:1rem;
  overflow-y:scroll;
  height: 100vh;

  .cross {
    position: absolute;;
    top:0;
    right:0;
    padding:1rem;
    svg {
      width: 1.5rem;
      height: 1.5rem;
    }
  }

  -webkit-touch-callout: none; /* iOS Safari */
      -webkit-user-select: none; /* Safari */
       -khtml-user-select: none; /* Konqueror HTML */
         -moz-user-select: none; /* Firefox */
          -ms-user-select: none; 
              user-select: none; 

  
  .main {
    visibility: hidden;
    &.visible {
      visibility: visible;
    }
    @media (min-width: 950px) {
      display:flex;
      .video {

      }
      .right {
        flex: 1 1 auto;
        padding-left:1.5rem;
        .title {
          margin-bottom: 1rem;
        }
        .title,
        .text {
          max-width: 23rem;
        }
        .text {
          padding-right: 1.5rem;
        }
      }

      .tags {
        line-height: 1.3;
        flex: 1 1 25%;
        
      }
      .video {
        // height:100%;
        width: 66%;
        video {
          width: 100% !important;
          height: 100%;
          display: block;
          object-fit:contain;
          object-position: 100% 0%;
        }
      }              
    }
    @media (max-width: 949px) {
      .video {
        margin-top: 4rem;
        video {
          max-width: 100%;
        }
      }
    }
    .link {
      margin:1rem 0;
      span {
        text-decoration: line-through;  
      }
      a {
        text-decoration: underline;
        opacity: 1;
      }
      
    }
    .link,
    .tags,
    .text {
      font-size: 1.3rem;
      p {
        margin-bottom: 1rem;
      }
    }
    .tags {
      padding-bottom: 2rem;
    }
  }


 }
</style>
